// AUTO-GENERATED by scripts/gen-modules.mjs — do not edit.

// _opt breaks rolldown's static import-undefined analysis for optional exports.
function _opt<T>(mod: unknown, key: string): T[] {
  return ((mod as Record<string, unknown>)[key] as T[] | undefined) ?? []
}
const _mods: unknown[] = []
export const moduleRoutes: unknown[] = []
export const moduleNav: unknown[] = []
// Nav-Pfad → Modul-ID (für Freigaben: module.<id>, docs/specs/access-groups.md §9)
export const moduleNavOwners: Record<string, string> = Object.fromEntries(
  [],
)
export const moduleI18n: unknown[] = []
export const moduleBuddyWidgets: unknown[] = _mods.flatMap(m => _opt(m, "buddyWidgets"))
export const moduleBuddyMediaWidgets: unknown[] = _mods.flatMap(m => _opt(m, "buddyMediaWidgets"))
export const moduleWorkspaceTabs: unknown[] = _mods.flatMap(m => _opt(m, "workspaceTabs"))
export const moduleSlotBlocks: unknown[] = _mods.flatMap(m => _opt(m, "slotBlocks"))
export const moduleMediaSources: unknown[] = _mods.flatMap(m => _opt(m, "mediaSources"))
export const moduleMediaWorkflows: unknown[] = _mods.flatMap(m => _opt(m, "mediaWorkflows"))
